/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    CreateSeatingGroupBody,
    GetSeatingGroups200,
    GetSeatingGroupsParams,
    RequestStatusResponseResponse,
    SeatingGroup,
    UpdateSeatingGroupBody,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Create a seating group and assign bookings to it
 */
export const createSeatingGroup = (
    createSeatingGroupBody: CreateSeatingGroupBody,
    signal?: AbortSignal,
) => {
    return customInstance<SeatingGroup>({
        url: `/seating-groups`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createSeatingGroupBody,
        signal,
    });
};

export const getCreateSeatingGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createSeatingGroup>>,
        TError,
        { data: CreateSeatingGroupBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof createSeatingGroup>>,
    TError,
    { data: CreateSeatingGroupBody },
    TContext
> => {
    const mutationKey = ['createSeatingGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createSeatingGroup>>,
        { data: CreateSeatingGroupBody }
    > = (props) => {
        const { data } = props ?? {};

        return createSeatingGroup(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateSeatingGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof createSeatingGroup>>
>;
export type CreateSeatingGroupMutationBody = CreateSeatingGroupBody;
export type CreateSeatingGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Create a seating group and assign bookings to it
 */
export const useCreateSeatingGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createSeatingGroup>>,
        TError,
        { data: CreateSeatingGroupBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof createSeatingGroup>>,
    TError,
    { data: CreateSeatingGroupBody },
    TContext
> => {
    const mutationOptions = getCreateSeatingGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get all seating groups for a timeslot
 */
export const getSeatingGroups = (params: GetSeatingGroupsParams, signal?: AbortSignal) => {
    return customInstance<GetSeatingGroups200>({
        url: `/seating-groups`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetSeatingGroupsQueryKey = (params?: GetSeatingGroupsParams) => {
    return [`/seating-groups`, ...(params ? [params] : [])] as const;
};

export const getGetSeatingGroupsQueryOptions = <
    TData = Awaited<ReturnType<typeof getSeatingGroups>>,
    TError = APIErrorResponseResponse,
>(
    params: GetSeatingGroupsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getSeatingGroups>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSeatingGroupsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeatingGroups>>> = ({ signal }) =>
        getSeatingGroups(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getSeatingGroups>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetSeatingGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getSeatingGroups>>>;
export type GetSeatingGroupsQueryError = APIErrorResponseResponse;

/**
 * @summary Get all seating groups for a timeslot
 */

export function useGetSeatingGroups<
    TData = Awaited<ReturnType<typeof getSeatingGroups>>,
    TError = APIErrorResponseResponse,
>(
    params: GetSeatingGroupsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getSeatingGroups>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetSeatingGroupsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Add or remove bookings from a seating group
 */
export const updateSeatingGroup = (id: number, updateSeatingGroupBody: UpdateSeatingGroupBody) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/seating-groups/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateSeatingGroupBody,
    });
};

export const getUpdateSeatingGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateSeatingGroup>>,
        TError,
        { id: number; data: UpdateSeatingGroupBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateSeatingGroup>>,
    TError,
    { id: number; data: UpdateSeatingGroupBody },
    TContext
> => {
    const mutationKey = ['updateSeatingGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateSeatingGroup>>,
        { id: number; data: UpdateSeatingGroupBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return updateSeatingGroup(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateSeatingGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof updateSeatingGroup>>
>;
export type UpdateSeatingGroupMutationBody = UpdateSeatingGroupBody;
export type UpdateSeatingGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Add or remove bookings from a seating group
 */
export const useUpdateSeatingGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateSeatingGroup>>,
        TError,
        { id: number; data: UpdateSeatingGroupBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof updateSeatingGroup>>,
    TError,
    { id: number; data: UpdateSeatingGroupBody },
    TContext
> => {
    const mutationOptions = getUpdateSeatingGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Disband a seating group
 */
export const deleteSeatingGroup = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/seating-groups/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteSeatingGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteSeatingGroup>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeatingGroup>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteSeatingGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteSeatingGroup>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return deleteSeatingGroup(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteSeatingGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteSeatingGroup>>
>;

export type DeleteSeatingGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Disband a seating group
 */
export const useDeleteSeatingGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteSeatingGroup>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteSeatingGroup>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteSeatingGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
